import CheckoutSuccessAdvancedView from './CheckoutSuccessAdvancedView'

export default CheckoutSuccessAdvancedView
